import {
  IonIcon,
  IonItem,
  IonList,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import { chevronBackOutline, eyeOutline, funnel } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import "./N2NGlobalSearch.scss";
import Call from "../../components/Shared/Call/call";
import { CONSTANTS } from "../../constants";
import { globalSearchService } from "../GlobalSearch/GlobalSearch.service";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../components/Shared/Loader/Loader";
import SelectSite from "../NurseManagement/components/SelectSiteModal/SelectSiteModal";
import { SpecialityModal } from "../UserChat/UserChatWebComponent/UserChatWebComponent";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";

const N2NGlobalSearch = () => {
  const history = useHistory();
  const { t } = useTranslation("messages");

  const [sitesList, setSitesList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [showSiteModal, setShowSiteModal]: any = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedSites, setSelectedSites] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const clearData = () => {
    setSearchQuery("");
  };

  const handleFetchSitesApi = async () => {
    const response = await globalSearchService.fetchSitesList({});
    const mappedData = response?.result?.map((res: any) => {
      return {
        dataName: res?.site_name,
        dataId: res?.site_id,
      };
    });
    setSitesList(mappedData);
  };

  const handleFetchusersApi = async (params: any, pageNo: number) => {
    setIsLoading(true);
    const response = await globalSearchService.fetchUsers(params);
    setUsersList(response?.result);
    setIsLoading(false);
  };

  useEffect(() => {
    handleFetchSitesApi();
    const payload = {
      name: "",
      specialty: "",
      site: "",
    };
    handleFetchusersApi(payload, 1);
  }, []);

  const handleSearch = (event: any) => {
    setSearchQuery(event.target.value);
    const payload = {
      name: event.target.value,
      specialty: "",
      site: selectedSites?.join(","),
    };
    handleFetchusersApi(payload, pageNumber);
  };

  const onSitesModalClose = (sites: []) => {
    const selectedSiteIds = sites?.map((site: any) => site?.dataId);
    setSelectedSites(selectedSiteIds);
    setSitesList((prev:any)=>prev?.map((site:any)=>{
      if(selectedSiteIds?.includes(site?.dataId)){
        return {
          ...site,
          isSelected:true
        }
      }else{
        return site
      }
    }))
    const payload = {
      name: searchQuery,
      specialty: "",
      site: selectedSiteIds?.join(","),
    };
    handleFetchusersApi(payload, 1);
  };

  const handleFilterButtonClick = () => {
    setShowSiteModal(true);
  };

  return (
    <>
      <div className="n2n-global-search">
        <div className="file-share-list-container">
          <div className="file-share-select-user-header">
            <div
              className="back-icon"
              onClick={() => {
                history.push("/client/home");
              }}
            >
              <IonIcon icon={chevronBackOutline} />
            </div>
            <div className="header-label">{t("n2nSearch")}</div>
            <div className="add-fav-user-btn-container"></div>
          </div>
        </div>

        <div className="search-bar">
          <div className="search-bar-container">
            <div className="search-box-container">
              <IonSearchbar
                onIonChange={(event: any) => handleSearch(event)}
                className="search-box"
                placeholder={t("searchByName")}
                showClearButton="always"
                searchIcon={""}
                debounce={500}
              />
            </div>
          </div>
          <div className="filter-button" onClick={handleFilterButtonClick}>
            <IonIcon className="filter-icon" icon={funnel} />
          </div>
        </div>
        {!isLoading ? (
          usersList.length ? (
            <InfiniteScroll
              dataLength={usersList?.length}
              // height={`73vh`}
              className="n2n-doctor-list-container"
              next={() => handleFetchusersApi({}, pageNumber + 1)}
              hasMore={true}
              loader={
                // showLoader ? (
                <div className="global-search-loader">
                  <Loader />
                </div>
                // ) : null
              }
            >
              {usersList?.map((doctor: any) => {
                return <N2nDoctorCard data={doctor} />;
              })}
            </InfiniteScroll>
          ) : (
            <div className="empty-result">
              <p>{t("noResultFound")}</p>
            </div>
          )
        ) : (
          <div className="loader-container">
            <Loader></Loader>
          </div>
        )}
      </div>
      <SelectSite
        showModal={showSiteModal}
        onOk={(selectedSites: any) => {
          onSitesModalClose(selectedSites);
          setShowSiteModal(false);
        }}
        listData={sitesList}
        onCancel={() => {
          setShowSiteModal(false);
        }}
      />
    </>
  );
};

export default N2NGlobalSearch;

export const N2nDoctorCard = ({ data }: any) => {
  const { t } = useTranslation("messages");
  const [isOpenSpecialityContainer, setIsOpenSpecialityContainer] =
    useState<boolean>(false);
  const [isOpenSitesContainer, setIsOpenSitesContainer] =
    useState<boolean>(false);
  const history = useHistory();

  const siteNames = data?.site?.map((site: any) => site?.site_name)?.join(",");

  const maxSubtitleLength = 30;
  const specialityNames = data?.network[0]?.user_specialties;
  const shouldShowEyeIcon = specialityNames?.length > maxSubtitleLength;
  const displayedSubtitle = shouldShowEyeIcon
    ? `${specialityNames?.substring(0, maxSubtitleLength)}...`
    : specialityNames;

  const subtitleArray = Array.isArray(specialityNames)
    ? specialityNames
    : specialityNames?.split(",")?.map((item: any) => item?.trim());

  const shouldShowSiteEyeIcon = siteNames?.length > maxSubtitleLength;
  const displayedSiteSubtitle = shouldShowSiteEyeIcon
    ? `${siteNames?.substring(0, maxSubtitleLength)}...`
    : siteNames;

  const siteSubtitleArray = Array.isArray(siteNames)
    ? siteNames
    : siteNames?.split(",")?.map((item: any) => item?.trim());


  const constructUserFormat = () =>{
    return {
      guid:data?.network[0]?.user_guid,
      firstName: data?.first_name,
      lastName: data?.last_name,
      profilePic:data?.profile_pic,
      speciality: data?.network[0]?.user_specialties,
      id: data?.network[0]?.network_user_id
    }
  }

  return (
    <>
      <div className="n2n-doctor-card">
        <img
          src={doctorsListService.mapProfilePicData(data?.profile_pic)}
          alt="Ionic logo"
          className="doctor-profile-image"
          onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
            const target = e.target as HTMLImageElement;
            target.src = "assets/images/defaultProfilePic.png";
          }}
        />

        <div className="name-and-detials-container">
          <p className="doctor-name">{`${data?.first_name} ${data?.last_name}`}</p>
          <div className="specialty-container">
              <p className="doctor-specialty-name">{displayedSubtitle ?? t("noSpeciality")}</p>
            {shouldShowEyeIcon && (
              <div onClick={() => setIsOpenSpecialityContainer(true)}>
                <IonIcon className="eye-icon" icon={eyeOutline} />
              </div>
            )}
          </div>
          <div className="sites-container">
            {/* <div className="site-icon">
              <SiteIcon/>
            </div> */}
            <p className="doctor-site">{displayedSiteSubtitle ?? t("noSite")}</p>
            {shouldShowSiteEyeIcon && (
              <div onClick={() => setIsOpenSitesContainer(true)}>
                <IonIcon className="eye-icon" icon={eyeOutline} />
              </div>
            )}
          </div>
        </div>

        <div className="actions-container">
          <div
            className="message-icon-container"
            onClick={() => {
              history.push({
                pathname: "/client/messages",
                state: {
                  selectedDoctorData: [constructUserFormat()],
                  mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
                  isFullscreen: true,
                  n2nNetwork:data?.network[0]?.network_code
                },
              });
            }}
          >
            {" "}
            <MessageIcon />
          </div>
          <Call selectedDoctorGuid={data?.network[0]?.user_guid} userNetwork={data?.network[0]?.network_code}></Call>
        </div>
        <div className="network-text">
          <div className="site-icon">
              <SiteIcon/>
            </div>
          <p>{data?.network[0]?.network_code}</p>
        </div>
      </div>
      <SpecialityModal
        isOpen={isOpenSpecialityContainer}
        onClose={() => setIsOpenSpecialityContainer(false)}
        values={subtitleArray}
        title={t("speciality")}
      />
      <SpecialityModal
        isOpen={isOpenSitesContainer}
        onClose={() => setIsOpenSitesContainer(false)}
        values={siteSubtitleArray}
        title={t("sites")}
      />
    </>
  );
};

export const MessageIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 92" fill="none">
      <path
        d="M90.0217 0H10.9783C8.06772 0.00347821 5.27738 1.15852 3.21931 3.21176C1.16124 5.265 0.00348638 8.0488 0 10.9525V59.1436C0.00348638 62.0473 1.16124 64.8311 3.21931 66.8844C5.27738 68.9376 8.06772 70.0927 10.9783 70.0961H15.3696V87.5216C15.361 88.4149 15.6223 89.29 16.1192 90.0331C16.6162 90.7762 17.3258 91.3528 18.1558 91.6879C18.9589 92.0111 19.841 92.0854 20.687 91.9009C21.533 91.7165 22.3037 91.282 22.8985 90.654L42.6549 70.0961H90.0217C92.9323 70.0927 95.7226 68.9376 97.7807 66.8844C99.8388 64.8311 100.997 62.0473 101 59.1436V10.9525C100.997 8.0488 99.8388 5.265 97.7807 3.21176C95.7226 1.15852 92.9323 0.00347821 90.0217 0ZM96.6087 59.1436C96.607 60.886 95.9124 62.5564 94.6775 63.7885C93.4426 65.0205 91.7682 65.7134 90.0217 65.7151H41.7174C41.4212 65.7151 41.1281 65.7749 40.8556 65.8908C40.5832 66.0068 40.3371 66.1765 40.1321 66.3898L19.7609 87.5216V67.9056C19.7609 67.3247 19.5295 66.7675 19.1178 66.3567C18.706 65.9459 18.1475 65.7151 17.5652 65.7151H10.9783C9.23183 65.7134 7.55742 65.0205 6.32251 63.7885C5.08759 62.5564 4.39305 60.886 4.3913 59.1436V10.9525C4.39305 9.21018 5.08759 7.5397 6.32251 6.30768C7.55742 5.07566 9.23183 4.38275 10.9783 4.38101H90.0217C91.7682 4.38275 93.4426 5.07566 94.6775 6.30768C95.9124 7.5397 96.607 9.21018 96.6087 10.9525V59.1436ZM65.167 16.9874C64.7689 16.3725 64.2227 15.8669 63.5783 15.5169C62.934 15.1668 62.212 14.9834 61.4783 14.9834C60.7446 14.9834 60.0226 15.1668 59.3782 15.5169C58.7338 15.8669 58.1877 16.3725 57.7896 16.9874L45.327 36.2003L38.6435 27.3068C38.2199 26.7844 37.6846 26.3631 37.0768 26.0737C36.4689 25.7843 35.8039 25.6341 35.1304 25.6341C34.4569 25.6341 33.7919 25.7843 33.1841 26.0737C32.5763 26.3631 32.041 26.7844 31.6174 27.3068L16.2478 47.753C15.7585 48.4039 15.4605 49.1778 15.3873 49.9882C15.3141 50.7985 15.4685 51.6131 15.8332 52.3409C16.1979 53.0686 16.7585 53.6806 17.4522 54.1083C18.1459 54.5361 18.9454 54.7626 19.7609 54.7626H81.5948C82.3843 54.7624 83.1592 54.5499 83.8379 54.1474C84.5165 53.7449 85.0738 53.1672 85.4512 52.4754C85.8285 51.7835 86.0119 51.0029 85.982 50.2158C85.9521 49.4287 85.71 48.6642 85.2813 48.0027L65.167 16.9874ZM19.7609 50.3816L35.1304 29.9354L43.7045 41.3414C43.9067 41.6345 44.1824 41.8696 44.5041 42.0233C44.8257 42.177 45.1821 42.244 45.5378 42.2176C45.8916 42.2056 46.2371 42.1082 46.5449 41.9339C46.8528 41.7595 47.1137 41.5134 47.3053 41.2165L61.4783 19.3662L81.5948 50.3816H19.7609Z"
        fill="#098689"
      />
    </svg>
  );
};

export const SiteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none">
      <path
        d="M53.3346 469.333H458.668C461.497 469.333 464.21 468.209 466.21 466.209C468.211 464.208 469.335 461.495 469.335 458.666V202.666C469.335 199.837 468.211 197.124 466.21 195.124C464.21 193.123 461.497 191.999 458.668 191.999H405.335V95.9994C405.335 93.1704 404.211 90.4573 402.21 88.4569C400.21 86.4565 397.497 85.3327 394.668 85.3327H341.335V74.666C341.335 66.1791 337.963 58.0398 331.962 52.0386C325.961 46.0374 317.822 42.666 309.335 42.666H202.668C194.181 42.666 186.042 46.0374 180.041 52.0386C174.039 58.0398 170.668 66.1791 170.668 74.666V85.3327H117.335C114.506 85.3327 111.793 86.4565 109.792 88.4569C107.792 90.4573 106.668 93.1704 106.668 95.9994V191.999H53.3346C50.5057 191.999 47.7926 193.123 45.7922 195.124C43.7918 197.124 42.668 199.837 42.668 202.666V458.666C42.668 461.495 43.7918 464.208 45.7922 466.209C47.7926 468.209 50.5057 469.333 53.3346 469.333ZM405.335 213.333H448.001V447.999H405.335V213.333ZM288.001 447.999H224.001V373.333H288.001V447.999ZM192.001 74.666C192.001 71.837 193.125 69.1239 195.125 67.1235C197.126 65.1232 199.839 63.9993 202.668 63.9993H309.335C312.164 63.9993 314.877 65.1232 316.877 67.1235C318.878 69.1239 320.001 71.837 320.001 74.666V181.333C320.001 184.162 318.878 186.875 316.877 188.875C314.877 190.876 312.164 191.999 309.335 191.999H202.668C199.839 191.999 197.126 190.876 195.125 188.875C193.125 186.875 192.001 184.162 192.001 181.333V74.666ZM128.001 106.666H170.668V181.333C170.668 189.82 174.039 197.959 180.041 203.96C186.042 209.961 194.181 213.333 202.668 213.333H309.335C317.822 213.333 325.961 209.961 331.962 203.96C337.963 197.959 341.335 189.82 341.335 181.333V106.666H384.001V447.999H309.335V362.666C309.335 359.837 308.211 357.124 306.21 355.124C304.21 353.123 301.497 351.999 298.668 351.999H213.335C210.506 351.999 207.793 353.123 205.792 355.124C203.792 357.124 202.668 359.837 202.668 362.666V447.999H128.001V106.666ZM64.0013 213.333H106.668V447.999H64.0013V213.333Z"
        fill="#098689"
      />
      <path
        d="M224.001 138.665H245.335V159.999C245.335 162.828 246.458 165.541 248.459 167.541C250.459 169.542 253.172 170.665 256.001 170.665C258.83 170.665 261.543 169.542 263.544 167.541C265.544 165.541 266.668 162.828 266.668 159.999V138.665H288.001C290.83 138.665 293.543 137.542 295.544 135.541C297.544 133.541 298.668 130.828 298.668 127.999C298.668 125.17 297.544 122.457 295.544 120.456C293.543 118.456 290.83 117.332 288.001 117.332H266.668V95.9987C266.668 93.1697 265.544 90.4566 263.544 88.4562C261.543 86.4558 258.83 85.332 256.001 85.332C253.172 85.332 250.459 86.4558 248.459 88.4562C246.458 90.4566 245.335 93.1697 245.335 95.9987V117.332H224.001C221.172 117.332 218.459 118.456 216.459 120.456C214.458 122.457 213.335 125.17 213.335 127.999C213.335 130.828 214.458 133.541 216.459 135.541C218.459 137.542 221.172 138.665 224.001 138.665ZM181.335 266.665H202.668C205.497 266.665 208.21 265.542 210.21 263.541C212.211 261.541 213.335 258.828 213.335 255.999C213.335 253.17 212.211 250.457 210.21 248.456C208.21 246.456 205.497 245.332 202.668 245.332H181.335C178.506 245.332 175.793 246.456 173.792 248.456C171.792 250.457 170.668 253.17 170.668 255.999C170.668 258.828 171.792 261.541 173.792 263.541C175.793 265.542 178.506 266.665 181.335 266.665ZM213.335 309.332C213.335 306.503 212.211 303.79 210.21 301.79C208.21 299.789 205.497 298.665 202.668 298.665H181.335C178.506 298.665 175.793 299.789 173.792 301.79C171.792 303.79 170.668 306.503 170.668 309.332C170.668 312.161 171.792 314.874 173.792 316.875C175.793 318.875 178.506 319.999 181.335 319.999H202.668C205.497 319.999 208.21 318.875 210.21 316.875C212.211 314.874 213.335 312.161 213.335 309.332ZM245.335 266.665H266.668C269.497 266.665 272.21 265.542 274.21 263.541C276.211 261.541 277.335 258.828 277.335 255.999C277.335 253.17 276.211 250.457 274.21 248.456C272.21 246.456 269.497 245.332 266.668 245.332H245.335C242.506 245.332 239.793 246.456 237.792 248.456C235.792 250.457 234.668 253.17 234.668 255.999C234.668 258.828 235.792 261.541 237.792 263.541C239.793 265.542 242.506 266.665 245.335 266.665ZM245.335 319.999H266.668C269.497 319.999 272.21 318.875 274.21 316.875C276.211 314.874 277.335 312.161 277.335 309.332C277.335 306.503 276.211 303.79 274.21 301.79C272.21 299.789 269.497 298.665 266.668 298.665H245.335C242.506 298.665 239.793 299.789 237.792 301.79C235.792 303.79 234.668 306.503 234.668 309.332C234.668 312.161 235.792 314.874 237.792 316.875C239.793 318.875 242.506 319.999 245.335 319.999ZM309.335 266.665H330.668C333.497 266.665 336.21 265.542 338.21 263.541C340.211 261.541 341.335 258.828 341.335 255.999C341.335 253.17 340.211 250.457 338.21 248.456C336.21 246.456 333.497 245.332 330.668 245.332H309.335C306.506 245.332 303.793 246.456 301.792 248.456C299.792 250.457 298.668 253.17 298.668 255.999C298.668 258.828 299.792 261.541 301.792 263.541C303.793 265.542 306.506 266.665 309.335 266.665ZM309.335 319.999H330.668C333.497 319.999 336.21 318.875 338.21 316.875C340.211 314.874 341.335 312.161 341.335 309.332C341.335 306.503 340.211 303.79 338.21 301.79C336.21 299.789 333.497 298.665 330.668 298.665H309.335C306.506 298.665 303.793 299.789 301.792 301.79C299.792 303.79 298.668 306.503 298.668 309.332C298.668 312.161 299.792 314.874 301.792 316.875C303.793 318.875 306.506 319.999 309.335 319.999Z"
        fill="#098689"
      />
    </svg>
  );
};
